import { TemplateFilter } from "../TemplateList.types";

export const filterOptions: { label: string; value: TemplateFilter }[] = [
  { label: "Saved", value: "Saved" },
  { label: "Favorites", value: "Favorites" },
];
